import { render, staticRenderFns } from "./BreakingChangeConfirm.vue?vue&type=template&id=b10d3204&scoped=true"
import script from "./BreakingChangeConfirm.vue?vue&type=script&lang=ts"
export * from "./BreakingChangeConfirm.vue?vue&type=script&lang=ts"
import style0 from "./BreakingChangeConfirm.vue?vue&type=style&index=0&id=b10d3204&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10d3204",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b10d3204')) {
      api.createRecord('b10d3204', component.options)
    } else {
      api.reload('b10d3204', component.options)
    }
    module.hot.accept("./BreakingChangeConfirm.vue?vue&type=template&id=b10d3204&scoped=true", function () {
      api.rerender('b10d3204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/BreakingChangeConfirm.vue"
export default component.exports